import type { PropsWithChildren } from 'react';
import type React from 'react';

import { cn } from '@change/ds-utils';

const baseClasses = ['flex p-3 w-full'];

const unSelectedClasses = [
	'border-stroke-weaker bg-fill-inverse-strong rounded-large elevation-low border-2 border-solid',
	'hover:bg-fill-hover',
	'focus:border-stroke-focus',
];

const selectedClasses = ['bg-linear-to-b from-[#F0F7FF] to-blue-100 rounded-[10px]'];

type Props = {
	selected: boolean;
	['data-testid']?: string;
	['data-qa']?: string;
};

export const CardStyleWrapper: React.FC<PropsWithChildren<Props>> = ({
	selected,
	children,
	'data-testid': dataTestId,
	'data-qa': dataQa,
}) => {
	const selectedStateClasses = selected ? selectedClasses.join(' ') : unSelectedClasses.join(' ');
	const containerProps = {
		'data-testid': dataTestId,
		className: cn(baseClasses, selectedStateClasses),
		'data-qa': dataQa,
	};

	return (
		<div
			className={cn('rounded-large', {
				'elevation-elevated-selected bg-[linear-gradient(275deg,#0139BC_2.93%,#4BAEFF_96.39%)] p-0.5': selected,
			})}
		>
			<div {...containerProps}>{children}</div>
		</div>
	);
};
